// extracted by mini-css-extract-plugin
export var actions = "_qy-4";
export var item = "_qy-1";
export var price = "_qy-3";
export var quantity = "_qy-2";
export var table = "_qy-0";